import * as React from "react";
import { Icon } from "@utdanningsdirektoratet/icon";
import { IconButton } from "@utdanningsdirektoratet/button";
import { Link } from "@utdanningsdirektoratet/link";
import { Tooltip } from "@utdanningsdirektoratet/tooltip";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import styles from "./Vedlegg.module.less";

type VedleggProps = {
  id?: string;
  title: React.ReactNode | string;
  href?: string;
  tooltip?: string | boolean;
  onDelete?: () => void;
  disabled?: boolean;
  deleteTooltip?: React.ReactNode | string;
  className?: string;
};

const Vedlegg: React.FC<VedleggProps> = ({
  id,
  title,
  tooltip = title,
  href,
  onDelete,
  disabled,
  deleteTooltip = "Fjern dokument",
  className,
}) => {
  const classes = cls(
    {
      [styles.vedlegg]: true,
    },
    className,
  );

  return (
    <span id={id} className={classes}>
      <Icon icon="text document" />
      <span className={styles.vedleggLink}>
        <Tooltip
          as="span"
          align="left"
          message={tooltip}
          disabled={tooltip === false}
        >
          {href ? (
            <Link href={href} target="_blank" rel="noopener noreferrer">
              {title}
            </Link>
          ) : (
            <span className={styles.vedleggText}>{title}</span>
          )}
        </Tooltip>
      </span>
      {!disabled && onDelete ? (
        <Tooltip message={deleteTooltip} align="right">
          <IconButton onClick={onDelete} aria-label={`Fjern dokument ${title}`}>
            <Icon icon="trash" />
          </IconButton>
        </Tooltip>
      ) : null}
    </span>
  );
};

export default Vedlegg;
